import {Component, Input} from '@angular/core';

/**
 * What a mapping line gets in the live preview's row: its values, a note
 * that the row gives it none, or nothing while `values` is `null` - when
 * that cannot be told.
 */
@Component({
  selector: 'app-row-value',
  templateUrl: './row-value.component.html',
  styleUrls: ['./row-value.component.scss'],
  standalone: false,
})
export class RowValueComponent {
  @Input() values: readonly string[] | null = null;
  // The previewed row's number the values are labelled with; `null` for
  // no label.
  @Input() labelRow: number | null = null;
  // A newer preview is on its way.
  @Input() pending = false;
}
